import { z } from 'my-zod'
import { customerOrderPaymentMethodModel } from '../customer-order-payment-method'

const giftCardsToRedeem = z
  .object({
    balance: z.number().int().nonnegative(),
    redemptionCodeOrShortId: z.string().min(1)
  })
  .array()
  .optional()

const physicalPaymentSchema = z.object({
  type: z.literal('physical'),
  method: z.enum(['cash', 'check']),
  giftCardsToRedeem
})

const cardPaymentSchema = z.object({
  type: z.literal('card'),
  giftCardsToRedeem,
  name: customerOrderPaymentMethodModel.shape.name.optional(),
  paymentMethodId: z.string().min(1)
})

const terminalPaymentSchema = z.object({
  type: z.literal('terminal'),
  paymentIntentId: z.string().min(1),
  giftCardsToRedeem
})

const authorizationPaymentSchema = z.object({
  type: z.literal('authorization'),
  chargeId: z.string().min(1),
  giftCardsToRedeem
})

const giftCardPaymentSchema = z.object({
  type: z.literal('giftCard'),
  redemptionCodeOrShortId: z.string().min(1),
  balance: z.number().int().nonnegative(),
  giftCardsToRedeem
})

const cardRefundSchema = z.object({
  type: z.literal('card'),
  paymentMethodId: z.string().min(1)
})

const giftCardRefundSchema = z.object({
  type: z.literal('giftCard'),
  shortId: z.string().min(1)
})

const noPaymentSchema = z.object({
  type: z.literal('none')
})

export const orderPaymentSchema = z.union([
  physicalPaymentSchema,
  cardPaymentSchema,
  authorizationPaymentSchema,
  terminalPaymentSchema,
  noPaymentSchema,
  giftCardPaymentSchema
])

export type OrderPayment = z.infer<typeof orderPaymentSchema>

export const orderRefundSchema = z.union([
  z.object({
    type: z.literal('cash')
  }),
  z.object({
    type: z.literal('auto')
  }),
  cardRefundSchema,
  giftCardRefundSchema,
  noPaymentSchema
])

export type OrderRefund = z.infer<typeof orderRefundSchema>
